<template>
<!--  打开弹框的时候,页面头部抖动 todo-->
    <copy-shell
        v-if="dialogShow"
        :dialog-show="dialogShow"
        :title-drawer="$t('Cart')"
        @close="closeHandle"
        :is-shop-car="true"
    >
        <div class="drawer-content-inner shop-car"
            v-loading="loading"
        >
          <!--顶部需要固定,不能滚动-->
          <div
            v-if="shopCarList.length"
            class="header-btn display-flex space-between">
            <el-checkbox
              :indeterminate="isIndeterminate"
              :value="checkAll"
              @change="handleCheckAllChange"
            >{{$t('Select_All')}}</el-checkbox>
            <div
              @click="clearHandle"
              class="btn-right pointer">
              <i class="iconfont iconqingkong"></i>
              <span>{{$t('withgold.clearEmipt')}}</span>
            </div>
          </div>
          <div class="shop-car-data-content">
            <div
              v-for="(item,index) in shopCarList"
              :key="index"
              class="data-item">
              <div class="data-left">
                <el-checkbox
                  :value="item.checked"
                  @change="(val) => itemCheckChange(val,index)"
                >
                </el-checkbox>
                <div class="img-box">
                  <img class="product-img" :src="item.frontImg" alt="">
                </div>
                <div class="product-info">
                  <div class="product-name">{{item.productName}}</div>
                  <div class="integral-line">
                    <span class="text">{{$t('integral')}} </span>
                    <span class="integral-number">{{item.quantity * item.unitPrice}}</span>
                  </div>
                </div>
              </div>
              <div class="data-right">
                <div
                  @click="subHandle(item,index)"
                  class="sub-btn btn up-down-left-right-center">
                  <span>-</span>
                </div>
                <span class="item-num">{{item.quantity}}</span>
                <div
                  @click="addHandle(item,index)"
                  class="add-btn btn up-down-left-right-center">
                  <span>+</span>
                </div>
              </div>
            </div>
            <div
              v-if="!shopCarList.length"
              class="center">{{$t('root.noData')}}</div>
          </div>
        </div>
        <div class="footer-box padding20"
             slot="footer"
        >
          <div class="data-box">
            <div class="box-left">
              {{$t('My_Points')}}: {{myIntegral}}
            </div>
            <el-divider
              class="divider-box"
              direction="vertical"

            ></el-divider>
            <div class="box-right">
              {{$t('Deduction_of_points')}}: {{totalIntegral}}
            </div>
          </div>
            <el-button
              class="open-btn"
              :class="{'disable-btn': submitDisabled}"
              :disabled="submitDisabled"
              style="width: 100%"
              type="primary"
              :loading="settLoading"
              @click="settleHandle"
            >{{$t('Go_to_checkout')}}</el-button>
        </div>
    </copy-shell>
</template>

<script>
    import { mapGetters } from 'vuex'
    import copyShell from '@/components/common/copyShell';
    import { queryShopCarDetail,editCarProductNum,clearShopCar } from '@/api/userCenter.js';
  export default {
    name: 'shopCarDialog',
    props: {
      dialogShow: {
        type: Boolean,
        default: false,
      }
    },
    components:{
      copyShell,
    },
    data() {
      return {
        loading: false,
        checkAll: false,
        shopCarList:[],
        myIntegral: 0,
        settLoading: false,
      };
    },
    created(){
      this.getCarInfo();
    },
    computed: {
      ...mapGetters(['userInfo',]),
      totalIntegral(){
        let total = 0;
        for (let i = 0; i < this.shopCarList.length; i++) {
          if(this.shopCarList[i].checked){
            total += this.shopCarList[i].quantity * this.shopCarList[i].unitPrice;
          }
        }
        return total;
      },
      isIndeterminate(){
        if(!this.shopCarList.length){
          return false;
        }else {
          let isAllChecked = this.shopCarList.every((item) => {
            return item.checked;
          });
          let isSomeoneChecked = this.shopCarList.some((item) => {
            return item.checked;
          });

          if(!isAllChecked && isSomeoneChecked){
            return true;
          }else {
            return false;
          }
        }
      },
      submitDisabled(){
        if(!this.shopCarList || !this.shopCarList.length){
          return true;
        }else {
          return false;
        };
      }
    },
    methods: {
      getCarInfo(){
        queryShopCarDetail().then((res) => {
          this.$emit('send-car-data',res.data);
          //res对象 rewardPoint积分,  shippingInfo,收货信息,cartSize,购物车数量
          this.shopCarList = res.data.cartList;
          this.myIntegral = res.data.rewardPoint;
        })
      },
      closeHandle(){
        // this.getCarInfo();
        this.$emit('close');
      },
      handleCheckAllChange(val) {
        if(!this.shopCarList.length) return;
        this.checkAll = val;
        if(val){
         //全选
          for (let i = 0; i < this.shopCarList.length; i++) {
            this.$set(this.shopCarList[i], 'checked', true);
          }
        }else {
          //反选
          for (let i = 0; i < this.shopCarList.length; i++) {
            this.$set(this.shopCarList[i], 'checked', false);
          }
        }
      },
      settleHandle(){
        if(!this.shopCarList.length) return;
        // 是否有勾选
        this.settLoading = true;
        if(!this.isIndeterminate && !this.checkAll){
          this.$message({
            type: 'warning',
            message: '请选择你要结算的商品'
          });
          this.settLoading = false;
          return;
        }
        //是否积分不够
        if(this.myIntegral < this.totalIntegral){
          this.$message({
            type: 'warning',
            message: '积分不够 '
          });
          this.settLoading = false;
          return;
        }
        let settleProductArr = [];
        for (let i = 0; i < this.shopCarList.length; i++) {
          if(this.shopCarList[i].checked){
            let itemObj = {
              ...this.shopCarList[i],
            }
            if(this.shopCarList[i].productType == 1){
              itemObj.remark = '';
            }else if(this.shopCarList[i].productType == 2){
              itemObj.mtId = '';
            }
            settleProductArr.push(itemObj);
          }
        }
        this.settLoading = false;
        this.$emit('settlehandle',settleProductArr);
      },
      clearHandle(){
        // 是否框
        this.$confirm('是否清空购物车?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          confirmButtonClass: 'car-sure-btn'
        }).then(() => {
          clearShopCar().then((res) => {
            if(res&&res.code&&res.code == 200){
              this.shopCarList = [];
              this.getCarInfo();
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      itemCheckChange(val,index){
        this.$set(this.shopCarList[index],'checked',val);
        let isAllChecked = this.shopCarList.every((item) => {
          return item.checked;
        });
        if(isAllChecked){
          this.checkAll = true;
        }else {
          this.checkAll = false;
        }
      },
      addHandle(item,index){
        // this.loading = true;
        editCarProductNum({
          id: item.cartId,
          quantity: item.quantity + 1,
        }).then((res) => {
          // this.loading = false;
          // this.getCarInfo();
          this.$set(this.shopCarList[index], 'quantity',this.shopCarList[index].quantity + 1);
        }).catch((res) => {
          // this.loading = false;
        })
      },
      subHandle(item,index){

        // this.loading = true;
        editCarProductNum({
          id: item.cartId,
          quantity: item.quantity - 1,
        }).then((res) => {
          // this.loading = false;
          // this.getCarInfo(); // 拉取数据会导致勾选的商品取消勾选了
          if(item.quantity == 1){
            // 删除购物车
            this.shopCarList.splice(index,1);
            this.$emit('send-quantity');
          }else {
            this.$set(this.shopCarList[index], 'quantity',this.shopCarList[index].quantity - 1);
          }

        }).catch((res) => {
          // this.loading = false;
        })
      },
    }
  };
</script>
<style lang="scss">
@import "../../../assets/scss/variable";
.car-sure-btn {
  background-color: $themeColor!important;
  border-color: $themeColor!important;
}
</style>
<style lang="scss" scoped>
    @import "../../../assets/scss/variable";

.shop-car {
  .header-btn {
    margin-bottom: 20px;
  }
  .shop-car-data-content {
    .data-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      font-size: 14px;
      .data-left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .img-box {
          width: 48px;
          height: 48px;
          margin: 0 10px;
          .product-img {
            width: 100%;
            height: 100%;
          }
        }
        .product-info {
            .product-name {
              color: #333333;
              margin-bottom: 10px;
            }
            .text {
              color: #999999;
            }
          .integral-number {
            color: $themeColor;
          }
        }
      }
      .data-right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .item-num {
          margin: 0 5px;
        }
        .btn {
          width: 20px;
          height: 20px;
          border: 1px solid #333333;
          font-size: 16px;
          cursor: pointer;
          &.add-btn {
            background-color: #333333;
            color: #ffffff;
          }
        }
      }
    }
  }
}
    .footer-box {
        padding-top: 10px;
        padding-bottom: 10px;
        .data-box {
          display: flex;
          justify-content: space-around;
          font-size: 14px;
          color: #333333;
          margin-bottom: 20px;
          .box-left,
          .box-right {
            width: 50%;
          }
          /deep/ .el-divider {
            background-color: #333333;
            margin-right: 20px;
          }
        }
      .open-btn {
        &.disable-btn {
          background-color: gray;
          border-color: gray;
        }
      }
    }
</style>
